<app-home-fundamentals-card [type]="cardType" [content]="contentTemplate" [actions]="actionsTemplate">
</app-home-fundamentals-card>

<ng-template #contentTemplate>
    <div>
        <ng-container *ngIf="roadmaps$ | async as roadmaps; else contentLoading">
            <app-home-roadmaps-wysiwyg [roadmaps]="roadmaps"></app-home-roadmaps-wysiwyg>
        </ng-container>
        <ng-template #contentLoading>
            <app-loading-skeleton [rows]="1" [rowHeight]="20"></app-loading-skeleton>
            <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
            <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
            <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
        </ng-template>
    </div>
</ng-template>

<ng-template #actionsTemplate>
    <ng-container *ngIf="roadmaps$ | async as roadmaps; else actionsLoading">
        <ng-container *appProducts="[productEnum.GENESYS_CLOUD_CX]">
            <a
                class="link-btn"
                [routerLink]="'/home/roadmap-archives'"
                [queryParams]="{ product: (selectedProduct$ | async)?.uid }"
                matTooltip="Visit to see past roadmap webinars"
                [matTooltipShowDelay]="1000"
                [matTooltipHideDelay]="2000">
                Visit the archives
                <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
            </a>
        </ng-container>
        <ng-template #actionsLoading>
            <app-loading-skeleton [rows]="1" [rowHeight]="18"></app-loading-skeleton>
        </ng-template>
    </ng-container>
</ng-template>
